export class RequestAccessCard {
  id: number;
  requestId: number;
  companyId: number;
  companyName: string;
  requestNumber: string;
  requestDate: Date;
  requestTypeId: number;
  requestTypeName: string;
  requestStatusId: number;
  requestStatusName: string;
  requestorId: number;
  requestorName: string;
  onBehalfId: number;
  onBehalfName: string;
  holderId: number;
  holderName: string;
  accessCardTypeId: number;
  accessCardTypeName: string;
  accessCardValidityId: number;
  accessCardValidityName: string;
  requestAccessCardReasonId: number;
  requestAccessCardReasonName: string;
  firstName: string;
  lastName: string;
  jobTitle: string;
  email: string;
  phone: string;
  startDate: Date;
  endDate: Date;
  qstpBadgeNumber: string;
  newBadgeNumber: string;
  justification: string;
  collectedByName: string;
  collectedById: string;

  isTemporaryCard: boolean;
  isDriverCard: boolean;
  isCollected: boolean;

  accessCardRequestType: string;

  badgeNumber: string;
  requestAccessCardCancellationReasonId: number;
  requestAccessCardCancellationReasonName: string;
  VirualId: number;
 
}




// WEBPACK FOOTER //
// ./src/app/core/models/request-access-card.ts